// src/index.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';
import ConfigService from './Core/ConfigService';

import { GtagLoader } from './Components/GtagLoader/GtagLoader';

ConfigService.get().then(() => {
    const container = document.getElementById('root');
    if (!container) return;
    const root = createRoot(container);

    root.render(
        <React.StrictMode>
            {/* 1. Load gtag.js, define window.gtag & default consent */}
            <GtagLoader />
                {/* 3. Your App (AnalyticsWrapper inside App will wait for consent before init) */}
                <App />
        </React.StrictMode>
    );
});

serviceWorker.unregister();
